<template>
  <div>
    <h1>Admin</h1>
    <h2>Fuck you</h2>
    <button @click="logout">Logout</button>
  </div>
</template>

<script>
  import firebase from 'firebase';

  export default {
    name: 'Admin',
    data () {
      return {};
    },
    methods: {
      logout: function () {
        firebase.auth().signOut().then(() => {
          this.$router.replace('login')
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin.vue